import { KybComplianceRow, KybComplianceStatus } from "../types";

export const KYB_STATUS_TABS: Array<{
  label: string;
  value: KybComplianceStatus;
  count: number;
}> = [
  { label: "Under review", value: "under-review", count: 343 },
  { label: "Started", value: "started", count: 302 },
  { label: "Not started", value: "not-started", count: 415 },
  { label: "Approved", value: "approved", count: 134 },
  { label: "Rejected", value: "rejected", count: 400 },
];

export const KYB_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "business_name_asc", label: "Business name (A-Z)" },
  { value: "business_name_desc", label: "Business name (Z-A)" },
  { value: "customer_name_asc", label: "Customer name (A-Z)" },
  { value: "customer_name_desc", label: "Customer name (Z-A)" },
];

export const KYB_BUSINESS_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "llc", label: "LLC" },
  { value: "sole-proprietorship", label: "Sole Proprietorship" },
  { value: "partnership", label: "Partnership" },
];

export const KYB_COUNTRY_OPTIONS = [
  { value: "all", label: "All" },
  { value: "nigeria", label: "Nigeria" },
  { value: "uk", label: "UK" },
  { value: "us", label: "US" },
];

export const KYB_TABLE_ROWS: KybComplianceRow[] = [
  {
    id: "marie-curie",
    customerName: "Marie Curie",
    customerEmail: "marie@bl.com",
    businessName: "HMA Logistics LLC",
    businessType: "LLC",
    pendingDocuments: 4,
    approvedDocuments: 5,
    rejectedDocuments: 1,
    country: "Nigeria",
    registrationDate: "Jun 15, 2025",
    status: "under-review",
  },
  {
    id: "rosalind-franklin",
    customerName: "Rosalind Franklin",
    customerEmail: "rosalind@line-experts.com",
    businessName: "Line Experts",
    businessType: "Sole Trader/Partnership",
    pendingDocuments: 2,
    approvedDocuments: 8,
    rejectedDocuments: 1,
    country: "UK",
    registrationDate: "Oct 30, 2025",
    status: "started",
  },
  {
    id: "galileo-galilei",
    customerName: "Galileo Galilei",
    customerEmail: "galileo@astronerds.com",
    businessName: "-",
    businessType: "",
    pendingDocuments: 0,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "-",
    registrationDate: "Nov 15, 2025",
    status: "not-started",
  },
  {
    id: "clara-barton",
    customerName: "Clara Barton",
    customerEmail: "clara@logistics-innovators.com",
    businessName: "Logistic Discoveries",
    businessType: "Sole Proprietorship",
    pendingDocuments: 31,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Nov 15, 2026",
    status: "approved",
  },
  {
    id: "ada-lovelace-innovatech",
    customerName: "Ada Lovelace",
    customerEmail: "ada@innovatech.org",
    businessName: "Logistic Innovations LLC",
    businessType: "LLC",
    pendingDocuments: 5,
    approvedDocuments: 4,
    rejectedDocuments: 3,
    country: "US",
    registrationDate: "Aug 12, 2025",
    status: "rejected",
  },
  {
    id: "ada-lovelace-tech-logistics",
    customerName: "Ada Lovelace",
    customerEmail: "ada@techlogistics.com",
    businessName: "Tech Logistics",
    businessType: "Sole Proprietorship",
    pendingDocuments: 0,
    approvedDocuments: 3,
    rejectedDocuments: 24,
    country: "Nigeria",
    registrationDate: "Sept 10, 2025",
    status: "under-review",
  },
  {
    id: "alan-turing",
    customerName: "Alan Turing",
    customerEmail: "alan@codegenius.com",
    businessName: "-",
    businessType: "",
    pendingDocuments: 0,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "UK",
    registrationDate: "Jul 20, 2025",
    status: "started",
  },
  {
    id: "grace-hopper",
    customerName: "Grace Hopper",
    customerEmail: "grace@merchantgrid.co",
    businessName: "Merchant Grid",
    businessType: "LLC",
    pendingDocuments: 1,
    approvedDocuments: 12,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Jan 08, 2026",
    status: "approved",
  },
  {
    id: "katherine-johnson",
    customerName: "Katherine Johnson",
    customerEmail: "katherine@orbitalfreight.com",
    businessName: "Orbital Freight",
    businessType: "LLC",
    pendingDocuments: 6,
    approvedDocuments: 2,
    rejectedDocuments: 1,
    country: "Nigeria",
    registrationDate: "Feb 02, 2026",
    status: "under-review",
  },
  {
    id: "nikola-tesla",
    customerName: "Nikola Tesla",
    customerEmail: "nikola@teslaworks.co",
    businessName: "Tesla Works",
    businessType: "Partnership",
    pendingDocuments: 3,
    approvedDocuments: 4,
    rejectedDocuments: 2,
    country: "UK",
    registrationDate: "Mar 18, 2026",
    status: "under-review",
  },
  {
    id: "hedy-lamarr",
    customerName: "Hedy Lamarr",
    customerEmail: "hedy@signalbridge.io",
    businessName: "Signal Bridge",
    businessType: "Sole Proprietorship",
    pendingDocuments: 9,
    approvedDocuments: 1,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Apr 06, 2026",
    status: "under-review",
  },
  {
    id: "tim-berners-lee",
    customerName: "Tim Berners-Lee",
    customerEmail: "tim@openwebpartners.com",
    businessName: "Open Web Partners",
    businessType: "Partnership",
    pendingDocuments: 4,
    approvedDocuments: 6,
    rejectedDocuments: 1,
    country: "Nigeria",
    registrationDate: "May 11, 2026",
    status: "under-review",
  },
  {
    id: "radia-perlman",
    customerName: "Radia Perlman",
    customerEmail: "radia@treepathlabs.ai",
    businessName: "Treepath Labs",
    businessType: "LLC",
    pendingDocuments: 7,
    approvedDocuments: 2,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Jun 14, 2026",
    status: "under-review",
  },
  {
    id: "margaret-hamilton",
    customerName: "Margaret Hamilton",
    customerEmail: "margaret@apollologic.io",
    businessName: "Apollo Logic",
    businessType: "LLC",
    pendingDocuments: 3,
    approvedDocuments: 5,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Jul 21, 2026",
    status: "under-review",
  },
  {
    id: "james-maxwell",
    customerName: "James Maxwell",
    customerEmail: "james@vectorgrid.co",
    businessName: "Vector Grid",
    businessType: "LLC",
    pendingDocuments: 2,
    approvedDocuments: 7,
    rejectedDocuments: 1,
    country: "UK",
    registrationDate: "Aug 03, 2026",
    status: "under-review",
  },
  {
    id: "dorothy-vaughan",
    customerName: "Dorothy Vaughan",
    customerEmail: "dorothy@northstartrade.com",
    businessName: "Northstar Trade",
    businessType: "LLC",
    pendingDocuments: 2,
    approvedDocuments: 3,
    rejectedDocuments: 1,
    country: "Nigeria",
    registrationDate: "Jan 12, 2026",
    status: "started",
  },
  {
    id: "elon-smythe",
    customerName: "Elon Smythe",
    customerEmail: "elon@atlascargo.co",
    businessName: "Atlas Cargo",
    businessType: "Partnership",
    pendingDocuments: 1,
    approvedDocuments: 5,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Feb 28, 2026",
    status: "started",
  },
  {
    id: "barbara-liskov",
    customerName: "Barbara Liskov",
    customerEmail: "barbara@solidchain.org",
    businessName: "Solid Chain",
    businessType: "Sole Proprietorship",
    pendingDocuments: 4,
    approvedDocuments: 2,
    rejectedDocuments: 1,
    country: "UK",
    registrationDate: "Mar 16, 2026",
    status: "started",
  },
  {
    id: "sophie-wilson",
    customerName: "Sophie Wilson",
    customerEmail: "sophie@armaturelogistics.com",
    businessName: "Armature Logistics",
    businessType: "LLC",
    pendingDocuments: 3,
    approvedDocuments: 4,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Apr 22, 2026",
    status: "started",
  },
  {
    id: "john-bardeen",
    customerName: "John Bardeen",
    customerEmail: "john@transistortraders.io",
    businessName: "Transistor Traders",
    businessType: "Partnership",
    pendingDocuments: 1,
    approvedDocuments: 6,
    rejectedDocuments: 1,
    country: "US",
    registrationDate: "May 29, 2026",
    status: "started",
  },
  {
    id: "annie-easley",
    customerName: "Annie Easley",
    customerEmail: "annie@trajectoryhub.com",
    businessName: "Trajectory Hub",
    businessType: "LLC",
    pendingDocuments: 0,
    approvedDocuments: 2,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Jun 30, 2026",
    status: "not-started",
  },
  {
    id: "linus-torvalds",
    customerName: "Linus Torvalds",
    customerEmail: "linus@kernelworks.fi",
    businessName: "Kernel Works",
    businessType: "Sole Proprietorship",
    pendingDocuments: 0,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "UK",
    registrationDate: "Jul 09, 2026",
    status: "not-started",
  },
  {
    id: "ida-rhodes",
    customerName: "Ida Rhodes",
    customerEmail: "ida@proofroute.ai",
    businessName: "Proof Route",
    businessType: "LLC",
    pendingDocuments: 0,
    approvedDocuments: 1,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Aug 17, 2026",
    status: "not-started",
  },
  {
    id: "mary-jackson",
    customerName: "Mary Jackson",
    customerEmail: "mary@flightledger.com",
    businessName: "Flight Ledger",
    businessType: "Partnership",
    pendingDocuments: 0,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Sept 04, 2026",
    status: "not-started",
  },
  {
    id: "george-boole",
    customerName: "George Boole",
    customerEmail: "george@logicgrain.uk",
    businessName: "Logic Grain",
    businessType: "LLC",
    pendingDocuments: 0,
    approvedDocuments: 0,
    rejectedDocuments: 0,
    country: "UK",
    registrationDate: "Oct 13, 2026",
    status: "not-started",
  },
  {
    id: "donald-knuth",
    customerName: "Donald Knuth",
    customerEmail: "donald@algorithmictrade.io",
    businessName: "Algorithmic Trade",
    businessType: "LLC",
    pendingDocuments: 1,
    approvedDocuments: 14,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "Feb 05, 2026",
    status: "approved",
  },
  {
    id: "adele-goldberg",
    customerName: "Adele Goldberg",
    customerEmail: "adele@smallworldcargo.com",
    businessName: "Small World Cargo",
    businessType: "Partnership",
    pendingDocuments: 0,
    approvedDocuments: 10,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Mar 10, 2026",
    status: "approved",
  },
  {
    id: "john-mccarthy",
    customerName: "John McCarthy",
    customerEmail: "john@lispventures.ai",
    businessName: "Lisp Ventures",
    businessType: "LLC",
    pendingDocuments: 2,
    approvedDocuments: 9,
    rejectedDocuments: 1,
    country: "UK",
    registrationDate: "Apr 14, 2026",
    status: "approved",
  },
  {
    id: "frances-allen",
    customerName: "Frances Allen",
    customerEmail: "frances@compilerlane.com",
    businessName: "Compiler Lane",
    businessType: "Sole Proprietorship",
    pendingDocuments: 1,
    approvedDocuments: 8,
    rejectedDocuments: 0,
    country: "US",
    registrationDate: "May 20, 2026",
    status: "approved",
  },
  {
    id: "edsger-dijkstra",
    customerName: "Edsger Dijkstra",
    customerEmail: "edsger@shortpathlogistics.nl",
    businessName: "Short Path Logistics",
    businessType: "Partnership",
    pendingDocuments: 0,
    approvedDocuments: 11,
    rejectedDocuments: 0,
    country: "Nigeria",
    registrationDate: "Jun 24, 2026",
    status: "approved",
  },
  {
    id: "claude-shannon",
    customerName: "Claude Shannon",
    customerEmail: "claude@bitstreamfreight.com",
    businessName: "Bitstream Freight",
    businessType: "LLC",
    pendingDocuments: 3,
    approvedDocuments: 3,
    rejectedDocuments: 5,
    country: "US",
    registrationDate: "Feb 19, 2026",
    status: "rejected",
  },
  {
    id: "alan-kay",
    customerName: "Alan Kay",
    customerEmail: "alan@dynabooksystems.org",
    businessName: "Dynabook Systems",
    businessType: "LLC",
    pendingDocuments: 2,
    approvedDocuments: 4,
    rejectedDocuments: 6,
    country: "UK",
    registrationDate: "Mar 27, 2026",
    status: "rejected",
  },
  {
    id: "john-von-neumann",
    customerName: "John von Neumann",
    customerEmail: "john@formaltrade.co",
    businessName: "Formal Trade",
    businessType: "Partnership",
    pendingDocuments: 1,
    approvedDocuments: 2,
    rejectedDocuments: 7,
    country: "Nigeria",
    registrationDate: "Apr 30, 2026",
    status: "rejected",
  },
  {
    id: "karen-spaerck-jones",
    customerName: "Karen Spärck Jones",
    customerEmail: "karen@queryflow.ai",
    businessName: "Query Flow",
    businessType: "Sole Proprietorship",
    pendingDocuments: 4,
    approvedDocuments: 1,
    rejectedDocuments: 8,
    country: "US",
    registrationDate: "May 18, 2026",
    status: "rejected",
  },
  {
    id: "leslie-lamport",
    customerName: "Leslie Lamport",
    customerEmail: "leslie@consensuslabs.dev",
    businessName: "Consensus Labs",
    businessType: "LLC",
    pendingDocuments: 0,
    approvedDocuments: 5,
    rejectedDocuments: 9,
    country: "UK",
    registrationDate: "Jun 26, 2026",
    status: "rejected",
  },
];
